import { computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { SideNavigationLink } from '@vendasta/protos/atlas/v1/types';
import { BusinessNavConfigService } from '../../config.service';
import { BusinessNavHostBridge, BusinessNavLinkTarget } from '../../host-bridge';

export interface ResolvedNavLink {
  kind: 'router' | 'href';
  url: string;
  target: '_blank' | null;
  rel: 'noopener' | null;
}

export function resolvedNavLink(item: Signal<SideNavigationLink | undefined>): Signal<ResolvedNavLink> {
  const bridge = inject(BusinessNavHostBridge);
  const serviceProviderId = toSignal(inject(BusinessNavConfigService).serviceProviderId$);
  return computed(() => resolveNavLink(item(), serviceProviderId(), bridge.isExternal(), bridge.effectiveLinkTarget()));
}

export function resolveNavLink(
  item: SideNavigationLink,
  configServiceProviderId: string | undefined,
  external: boolean,
  linkTarget: BusinessNavLinkTarget,
): ResolvedNavLink {
  if (!external && item.serviceProviderId === configServiceProviderId) {
    return { kind: 'router', url: item.path, target: null, rel: null };
  }
  const target = (external && linkTarget === '_blank') || item.openInNewTab ? '_blank' : null;
  return { kind: 'href', url: item.url, target, rel: target ? 'noopener' : null };
}
